import { Injectable, Inject, Output, EventEmitter, ElementRef } from '@angular/core';
// import { NotificationsService, NotificationType } from 'angular2-notifications';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { BehaviorSubject, map, Observable } from 'rxjs';
import { NavService } from './nav.service';
import { FileUploadService } from './file-upload.service';
// declare var google;

// import * as countries from '../../../assets/JSONFiles/countries+states+cities.json';
// import *  as  data from '../../../assets/tour/tourData.json';






// declare var EnjoyHint;
// declare var $;
@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  // For Message Board
  eventChatsSubs : any= [];
  isNewMessage = false;
  isLoadingProcessCompleted = false;
  tokenForPS : any = '';
  tokenForDB : any = '';
  UrlforpubSub: any=';'
  // --------------------







  // _loading_title = 'Loading';
  // timeZoneArr: any = [];
  // availableFuncGlobal: any;
  _show_loader: boolean = false;
  public loader: string = "show";
  readonly COMPACT_SCREEN_MAX_WIDTH = 1200;
  readonly desktopBarWidthPercent = 1.5;
  readonly compactBarWidthPercent = 1.05;

  private compactMediaQuery?: MediaQueryList;
  private readonly compactScreenSubject = new BehaviorSubject<boolean>(
    this.readIsCompactScreen()
  );
  readonly compactScreen$ = this.compactScreenSubject.asObservable();

  constructor(
    
    private http: HttpClient,
    public router: Router,
    private navService: NavService,
    private fileService: FileUploadService

  ) {
    this.bindCompactScreenWatcher();
  }

  public name: any = "";
  public settings: any;
  public modalConfig: any = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    class: 'modal-lg'
  };
  config = {
    animated: true,
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  };
  // formatBytes(bytes, decimals) {
  //   if (bytes == 0) return '0 Bytes';
  //   var k = 1024,
  //     dm = decimals <= 0 ? 0 : decimals || 2,
  //     sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  //     i = Math.floor(Math.log(bytes) / Math.log(k));
  //   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  // }
  get isCompactScreen(): boolean {
    return this.compactScreenSubject.value;
  }

  getChartBarWidthPercent(): number {
    return this.isCompactScreen
      ? this.compactBarWidthPercent
      : this.desktopBarWidthPercent;
  }

  getChartXTickInterval(): number {
    return this.isCompactScreen ? 8 : 4;
  }

  shouldShowChartXTick(index: number): boolean {
    return index === 0 || index % this.getChartXTickInterval() === 0;
  }

  isLastChartXTick(index: number, totalBars: number): boolean {
    const last = totalBars - 1;
    if (last < 0) {
      return false;
    }

    for (let i = last; i >= 0; i--) {
      if (this.shouldShowChartXTick(i)) {
        return index === i;
      }
    }

    return false;
  }

  getChartXTickTransform(index: number, totalBars: number): string {
    if (index === 0) {
      return 'none';
    }
    if (this.isLastChartXTick(index, totalBars)) {
      return 'translateX(-100%)';
    }
    return 'translateX(-50%)';
  }

  private readIsCompactScreen(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth <= this.COMPACT_SCREEN_MAX_WIDTH;
  }

  private bindCompactScreenWatcher(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.compactMediaQuery = window.matchMedia(
      `(max-width: ${this.COMPACT_SCREEN_MAX_WIDTH}px)`
    );
    this.compactScreenSubject.next(this.compactMediaQuery.matches);
    this.compactMediaQuery.addEventListener('change', (event) => {
      this.compactScreenSubject.next(event.matches);
    });
  }

  ConvertdecimaltoTWo(a: any) {
    return a.toFixed(2);
  }
  logoutuser() {
    localStorage.removeItem('token');
    localStorage.clear();
    this.router.navigate(['login']);
  }
  // showLoader(target: any) {
  //   let html = '<div class="card-disabled"><div class="card-portlets-loader"><div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div></div></div>';
  //   $(target).append(html);
  // }
  // getFeatPermissions(Feature) {

  //   var perms = [];
  //   perms = JSON.parse(localStorage.getItem("Roles"));
  //   perms = perms.filter(it => it.descp === Feature,)
  //   var roleArr = [];
  //   for (let i = 0; i < perms[0].functions.length; i++) {
  //     roleArr.push(perms[0].functions[i].descp);
  //   }
  //   return JSON.stringify(roleArr);
  // }

  // HideLoader(target: any) {
  //   $('.card-disabled').remove();
  // }


  private tokenValue: string = '';
  showNotification(type: any, title: any, message: any) {
    // this.notifications.create((title), message, NotificationType[type]);
  }
  convertSeconds(milliSeconds: any) {
    var utcSeconds = milliSeconds;
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(utcSeconds);
    return d;
  }
  // token getter
  get token(): string {
    let userdata = (localStorage.getItem("token"));
    let user = userdata === null ? '' : userdata;
    if (user != null) {
      this.tokenValue = user;
    } else {
      this.tokenValue = '';
    }
    return this.tokenValue;
  }
  lgModal(className: any) {
    document.getElementsByClassName('modal-dialog')[0].classList.add(className);
    if (document.getElementsByClassName('modal-dialog')[1] !== undefined) {
      document.getElementsByClassName('modal-dialog')[1].classList.add(className);
    }
  }
  // @Output() open: EventEmitter<any> = new EventEmitter();
  title = 'ROUTE MANAGEMENT PORTAL'
  toggle(str: any) {
    // this.open.emit(str);
  }

  empID: any;
  // navtitle(str) {
  //   this.title = str

  //  localStorage.setItem("nav-tittle", str)
  //  let path = 'ROUTE MANAGEMENT PORTAL'
  //  if (str === 'TRACK EVENT') {
  //    path = 'track'
  //  }
  //  if (str === 'EQUIPMENT LIST') {
  //    path = 'equipment'
  //  }
  //  if (str === 'BUS AND DRIVER INFO') {
  //    path = 'bus-driver-info'
  //  }
  //  if (str === 'BUS AND PASSENGER LOG') {
  //    path = 'passenger'
  //  }
  //  if (str === 'MESSAGE BOARD') {
  //    path = 'messages'
  //  }
  //  this.title = str;
  //  this.toggle(str)
  //  this.router.navigate([`/${path}`]);
  // }
  // InitTour(config, key: any) {
  //   var enjoyhint_instance = new EnjoyHint({

  //     onStart: () => {
  //       //do something
  //       this.changeModalStyle(true);
  //     },
  //     onEnd: () => {
  //       this.changeModalStyle(false);
  //       document.getElementsByClassName('navbar')[0]['style'].zIndex = '';
  //       localStorage.setItem(key, 'true');

  //       document.getElementsByClassName('mainCanvas').length > 0 ?
  //         document.getElementsByClassName('mainCanvas')[0]['style'].height = '60vh' : ''

  //       //do something
  //     },
  //     onSkip: () => {
  //       this.changeModalStyle(false);
  //       document.getElementsByClassName('navbar')[0]['style'].zIndex = '';
  //       localStorage.setItem(key, 'true');

  //       document.getElementsByClassName('mainCanvas').length > 0 ?
  //         document.getElementsByClassName('mainCanvas')[0]['style'].height = '60vh' : ''
  //       //do something
  //     }
  //   });

  //set script config
  //   enjoyhint_instance.set(config);
  //   document.getElementsByClassName('navbar')[0]['style'].zIndex = -1;
  //   //run Enjoyhint script
  //   enjoyhint_instance.run();
  // }
  // tourIsEnabled(key) {
  //   if (localStorage.getItem(key) !== null) {
  //     let val = localStorage.getItem(key);
  //     if (val === 'false') {
  //       return true
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return true;
  //   }
  // }
  // formatTime(seconds) {
  //   const h = Math.floor(seconds / 3600);
  //   const m = Math.floor((seconds % 3600) / 60);
  //   const s = Math.round(seconds % 60);
  //   return [
  //     h + ' h',
  //     m > 9 ? m + ' m' : (h ? '0' + m + ' m' : m + ' m' || '0'),
  //     s > 9 ? s + ' s' : '0' + s + ' s'
  //   ].filter(Boolean).join(':');
  // }
  // allowedFunction() {
  //   var availableFunc = localStorage.getItem('func');
  //   this.availableFuncGlobal = JSON.parse(atob(availableFunc));
  //   return this.availableFuncGlobal
  // }
  // getProObj() {
  //   var proStr = localStorage.getItem(this.settings.ETS_OBJ)
  //   if (proStr !== null || proStr !== undefined) {
  //     var obj = JSON.parse(atob(proStr))
  //     return obj
  //   }
  // }
  // drawMarker(pos, mMap, color, device, title?, stopOver = false, isDragable = false) {

  //   let link = ''
  //   if (device == 'cart' && color == 'red') {
  //     link = '../../../assets/img/redcat.svg';
  //   }
  //   else if (device == "etrapp") {
  //     if (color == 'red') {
  //       link = '../../../assets/img/redpinnew.svg'
  //     }
  //     else if (color == 'green') {
  //       link = 'b'
  //     }
  //     else if (color == 'yellow') {
  //       link = '../../../assets/img/yellowpinnew.svg'
  //     }
  //   }

  //   const icon = {

  //     url: link,
  //     scaledSize: new google.maps.Size(40, 40), // scaled size

  //   };

  //   if (color !== '') {
  //     return new google.maps.Marker({
  //       position: pos,
  //       map: mMap,
  //       scaledSize: new google.maps.Size(50, 50),
  //       // icon: 'http://maps.google.com/mapfiles/ms/icons/' + color + '.png',
  //       icon: icon,
  //       label: {
  //         text: ` ${pos.count}`,

  //         className: 'marker-label',
  //       },
  //       // draggable: isDragable,
  //       // title: title,
  //       // stopover: stopOver,
  //       // fitBounds: false,
  //       // MarkerType: BusID === undefined ? 'none' : BusID
  //     });
  //   }
  //   else {
  //     return new google.maps.Marker({
  //       position: pos,
  //       map: mMap,
  //       label: {
  //         text: ` ${pos.count}`,

  //         className: 'marker-label',
  //       },
  //       scaledSize: new google.maps.Size(50, 50),
  //     });
  //   }

  // }
  getDate(date: any) {
    let currentDate = new Date();
    date = new Date(date);
    let days = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / (1000 * 60 * 60 * 24));
    let months = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / (1000 * 60 * 60 * 24 * 30));
    let years = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) -
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())) / (1000 * 60 * 60 * 24 * 30 * 12));
    let returnDate = "";
    var newMonth;
    if (years > 0) {
      newMonth = months - (years * 12);
      returnDate += years + `${years > 1 ? ' years' : ' year'}`;
    }
    if (months > 0) {
      days = days - (months * 30);
      newMonth == undefined ? returnDate += months + `${months > 1 ? ' months' : ' month'} ` : returnDate += newMonth + `${months > 1 ? ' months' : ' month'} `;
    }
    return returnDate += days + ` day${days > 1 ? 's' : ''}`;
  }


  getDateToPatch(date: any){
    const dateObj = new Date(date);
  return {
    year: dateObj.getFullYear(),
    month: dateObj.getMonth() + 1,  // Months are 0-indexed, so add 1
    day: dateObj.getDate()
  };
  }

  datetoIS0(date:any){
    const startDateObject = date
    const startDate = new Date(startDateObject.year, startDateObject.month - 1, startDateObject.day);

    return startDate.toISOString();
  }
 
  getTimeDifference(date: any, obj: any, dev: number) {
    let date1: Date = date;
    switch (obj) {
      case "1hours":
       if (dev == 3){
          return this.previousDate(date1, 1);
        }
        break;
      case "3hours":
        if (dev == 3) {
          return this.previousDate(date1, 3);
        }
        break;
        case "6hours":
          if (dev == 3) {
            return this.previousDate(date1, 6);
          }
          break;
      case "24hours":
         if (dev == 3) {
          return this.previousDate(date1, 24);
        }
        break;
        case "48hours":
         if (dev == 3) {
          return this.previousDate(date1, 48);
        }
        break;
      case "168hours":
         if (dev == 3) {
          return this.previousDate(date1, 168);
        }
        break;
      case "30days":
       if (dev == 3) {
          return this.previousDate(date1, 720);
        }
        break;
      case "45days":
          if (dev == 3) {
             return this.previousDate(date1, 1080);
           }
           break;
      case "60days":
          if (dev == 3) {
              return this.previousDate(date1, 1440);
          }
             break;
    }
  }
 
  previousDate(date: any, hours: number) {
    ;
    date = new Date(date);
    let numberOfMiliseconds = date.getTime();
    let addMlSeconds = hours * 60 * 60 * 1000;
    let newDate = new Date(numberOfMiliseconds - addMlSeconds);
    return newDate;
  }


  toggleScreen(fullchart: any, chartRef: any) {
    const elem = fullchart?.nativeElement;

    if (!this.navService.fullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if ((document as any).mozCancelFullScreen) {
        (document as any).mozCancelFullScreen();
      } else if ((document as any).webkitExitFullscreen) {
        (document as any).webkitExitFullscreen();
      } else if ((document as any).msExitFullscreen) {
        (document as any).msExitFullscreen();
      }
    }

    setTimeout(() => {
      if (chartRef?.reflow) {
        chartRef.reflow();
      }
    }, 300);
  }



  fullHighChartScreen(fullchart: any, chartRef: any) {
    document.addEventListener('fullscreenchange', () => {
      debugger
      const isFullscreen = !!document.fullscreenElement;
      this.navService.fullScreen = isFullscreen;

      const container = fullchart?.nativeElement;
      if (container) {
        // First, check if there's no chart
        if (chartRef) {
          container.classList.remove('fullscreen');
          container.style.height = '200px';
          container.style.width = '';
        } else {
          // Chart exists
          if (isFullscreen) {
            container.classList.add('fullscreen');
            container.style.height = '100vh';
            container.style.width = '';
          } else {
            container.classList.remove('fullscreen');
            container.style.height = '60vh';
            container.style.width = '';
          }
        }
      }

      // Reflow only if chart exists
      setTimeout(() => {
        if (chartRef?.reflow) {
          chartRef.reflow();
        }
      }, 100);
    });
  }

  getDuration(start: string | number | Date, end: string | number | Date): string {
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();
    let diff = (endTime - startTime) / 1000;
    const hours = Math.floor(diff / 3600);
    diff %= 3600;

    const minutes = Math.floor(diff / 60);
    const seconds = Math.floor(diff % 60);

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else {
      return `${minutes}m ${seconds}s`;
    }
    
  }
  getLocalDate(dateString: string): Date {
    return new Date(dateString + 'Z'); 
  }

  /**
   * Parse alert dates from API (UTC) into a Date instant.
   * Display with Angular `date` pipe / toLocale* so the browser shows local time
   * (e.g. PK → UTC+5, US → local offset).
   * Supports DD/MM/YYYY[ HH:mm[:ss]] and ISO (with or without Z).
   */
  parseAlertDate(raw: string | Date | null | undefined): Date | null {
    if (!raw) return null;
    if (raw instanceof Date) {
      return isNaN(raw.getTime()) ? null : raw;
    }

    const value = String(raw).trim();
    if (!value) return null;

    // DD/MM/YYYY[ HH:mm[:ss]] — API wall clock is UTC
    const dmY = value.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/
    );
    if (dmY) {
      const day = Number(dmY[1]);
      const month = Number(dmY[2]) - 1;
      const year = Number(dmY[3]);
      const hour = Number(dmY[4] ?? 0);
      const minute = Number(dmY[5] ?? 0);
      const second = Number(dmY[6] ?? 0);
      const parsed = new Date(Date.UTC(year, month, day, hour, minute, second));
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    // ISO without timezone offset → treat as UTC (browsers otherwise use local)
    if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(\.\d+)?$/.test(value)) {
      const parsed = new Date(value.replace(' ', 'T') + 'Z');
      return isNaN(parsed.getTime()) ? null : parsed;
    }

    const fallback = new Date(value);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  /** Prefer API `date`, then `timeStamp`. */
  getAlertDisplayDate(alert: {
    date?: string | Date | null;
    timeStamp?: string | Date | null;
  } | null | undefined): Date | null {
    return this.parseAlertDate(alert?.date) ?? this.parseAlertDate(alert?.timeStamp);
  }

  /** Unwrap GetAllFiltered: array (full list) or { list, totalRecords } (paged). */
  extractAlertPage(res: any): {
    rows: any[];
    totalRecords: number;
    isPaged: boolean;
    /** Keyset cursor for the next page; null when there are no more rows. */
    nextCursor: string | null;
  } {
    const data = res?.data;

    if (Array.isArray(data)) {
      return { rows: data, totalRecords: data.length, isPaged: false, nextCursor: null };
    }

    const rows = data?.list ?? data?.List ?? [];
    const rawTotal = data?.totalRecords ?? data?.TotalRecords;
    const totalRecords = Number(rawTotal);
    const isPaged =
      data != null &&
      (Array.isArray(data.list) ||
        Array.isArray(data.List) ||
        rawTotal != null);

    return {
      rows,
      totalRecords: Number.isFinite(totalRecords) ? totalRecords : rows.length,
      isPaged,
      nextCursor: data?.nextCursor ?? data?.NextCursor ?? null
    };
  }

  /** API/PubSub status number or string → canonical alert status. */
  mapAlertStatus(
    status: number | string | null | undefined
  ): 'NotAcknowledged' | 'Acknowledged' | 'Resolved' {
    if (status === 1 || status === 'Acknowledged') return 'Acknowledged';
    if (status === 2 || status === 'Resolved') return 'Resolved';
    if (status === 0 || status === 'NotAcknowledged') return 'NotAcknowledged';
    return 'NotAcknowledged';
  }

  /** Ambient Air must not appear in Device Health / Device Map unresolved lists. */
  isAmbientAirType(type: string | null | undefined): boolean {
    const n = (type || '').trim().toLowerCase();
    return n === 'ambient air' || n.includes('ambient air');
  }

  /**
   * Whether an alert belongs in the unresolved alert lists. Ambient Air packets are stored
   * with an empty type as well as "Ambient Air", so both are excluded; the amplitude chart
   * still shows them.
   */
  isListableAlertType(type: string | null | undefined): boolean {
    return !!(type || '').trim() && !this.isAmbientAirType(type);
  }

  /** Read RSSI/dBm from cosmos/packet payload (flexible field names). */
  extractWifiDbm(device: any): number | null {
    if (!device) return null;

    const candidates = [
      device.rssi,
      device.Rssi,
      device.RSSI,
      device.wifiRssi,
      device.WifiRssi,
      device.wifi_rssi,
      device.wifiStrength,
      device.WifiStrength,
      device.signalStrength,
      device.SignalStrength,
      device.wifi?.rssi,
      device.wifi?.Rssi
    ];

    for (const raw of candidates) {
      if (raw == null || raw === '') continue;
      const n = typeof raw === 'number' ? raw : Number(String(raw).replace(/dBm/i, '').trim());
      if (!isNaN(n)) return n;
    }

    return null;
  }

  /**
   * dBm → bars
   * -50..-79 → 5 Excellent | -80..-89 → 4 Good | -90..-99 → 3 Average
   * -100..-109 → 2 Poor | -110..-120 → 1 Very poor | else → 0
   *
   * Note: WiFi RSSI from the device is negative. `0` (and any >= 0) means
   * unset / not reported — not an excellent signal.
   */
  dbmToWifiBars(dbm: number): number {
    // Device often sends rssi: 0 when strength is unavailable
    if (dbm >= 0) return 0;
    if (dbm >= -79 && dbm <= -50) return 5;
    if (dbm >= -89 && dbm <= -80) return 4;
    if (dbm >= -99 && dbm <= -90) return 3;
    if (dbm >= -109 && dbm <= -100) return 2;
    if (dbm >= -120 && dbm <= -110) return 1;
    // Stronger than -50 dBm (e.g. -40) still counts as excellent
    if (dbm > -50) return 5;
    return 0;
  }

  dbmToWifiLabel(dbm: number, bars: number): string {
    const quality =
      bars >= 5 ? 'Excellent' :
      bars === 4 ? 'Good' :
      bars === 3 ? 'Average' :
      bars === 2 ? 'Poor' :
      bars === 1 ? 'Very poor' :
      'No service';

    return `${Math.round(dbm)} dBm · ${quality}`;
  }

  resolveWifiSignal(
    device: any,
    defaultBars = 4
  ): { bars: number; label: string } {
    const dbm = this.extractWifiDbm(device);
    if (dbm == null) {
      return { bars: defaultBars, label: '' };
    }

    const bars = this.dbmToWifiBars(dbm);
    return { bars, label: this.dbmToWifiLabel(dbm, bars) };
  }

  /**
   * Canonical key for alert/detection type (handles "Ammonia (NH3)", etc.).
   * Used by Device Map markers/alerts and Amplitude Chart colors/legend.
   */
  getAlertTypeKey(type: string | null | undefined): string {
    const n = (type || '').trim().toLowerCase();
    if (!n) return 'unknown';

    if (n.includes('non-toxigenic') || n.includes('non toxigenic')) {
      return 'non-toxigenic';
    }
    if (n.includes('toxigenic')) return 'toxigenic';
    if (n.includes('c-diff') && n.includes('negative')) return 'negative';
    if (n === 'cleaning' || n.includes('cleaning agent')) return 'cleaning';
    if (n.includes('deep clean')) return 'deep-clean';

    if (n.includes('ammonia')) return 'ammonia';
    if (n.includes('methanol')) return 'methanol';
    if (n.includes('propanol')) return 'propanol';
    if (n.includes('toluene')) return 'toluene';
    if (n.includes('isopropyl')) return 'isopropyl-alcohol';
    if (n.includes('acetone')) return 'acetone';

    if (n === 'unknown') return 'unknown';
    return 'unknown';
  }

  /** Display color for alert type (Device Map + Amplitude Chart). */
  getAlertTypeColor(type: string | null | undefined): string {
    switch (this.getAlertTypeKey(type)) {
      case 'toxigenic':
        return '#dc3545';
      case 'non-toxigenic':
        return '#ffc107';
      case 'negative':
        return '#28a745';
      case 'cleaning':
        return '#6f42c1';
      case 'deep-clean':
        return '#17a2b8';
      case 'ammonia':
        // Avoid sky-blue — clashes with confidence dots on amplitude chart
        return '#c2410c';
      case 'methanol':
        return '#f97316';
      case 'propanol':
        return '#84cc16';
      case 'toluene':
        return '#ec4899';
      case 'isopropyl-alcohol':
        return '#14b8a6';
      case 'acetone':
        // Avoid indigo/blue — low contrast vs confidence dots
        return '#86198f';
      default:
        return '#6c757d';
    }
  }

  /** CSS class suffix: alert-{key} / type-{key} */
  getAlertTypeClass(type: string | null | undefined): string {
    return this.getAlertTypeKey(type);
  }

  /** True if type matches any label (supports "Ammonia" ↔ "Ammonia (NH3)"). */
  alertTypeMatches(
    type: string | null | undefined,
    ...candidates: string[]
  ): boolean {
    const key = this.getAlertTypeKey(type);
    if (key !== 'unknown') {
      return candidates.some((c) => this.getAlertTypeKey(c) === key);
    }
    const display = (type || '').trim().toLowerCase();
    return candidates.some((c) => display === c.trim().toLowerCase());
  }

  /** Relative label: "1 sec ago", "3 days ago", etc. */
  getRelativeTime(date: string | Date | null | undefined): string {
    const parsed = this.parseAlertDate(date);
    if (!parsed) return '';

    const diffSec = Math.max(
      0,
      Math.floor((Date.now() - parsed.getTime()) / 1000)
    );
    if (diffSec < 60) return `${diffSec} sec ago`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)} min ago`;
    if (diffSec < 86400) return `${Math.floor(diffSec / 3600)} hr ago`;
    return `${Math.floor(diffSec / 86400)} days ago`;
  }


  cleanData(data: Array<[number, number]>): Array<[number, number]> {
    const sorted = data.slice().sort((a, b) => a[0] - b[0]);
    const cleaned: Array<[number, number]> = [];
    let lastTimestamp = -Infinity;

    for (const point of sorted) {
      if (point[0] > lastTimestamp && Number.isFinite(point[1])) {
        cleaned.push(point);
        lastTimestamp = point[0];
      }
    }

    return cleaned;
  }


  isFormReady(Formdevice: any) {
    return Formdevice?.get('TestName')?.valid &&
      Formdevice?.get('Target')?.valid &&
      Formdevice?.get('SensorName')?.valid &&
      Formdevice?.get('CreatedBy')?.valid;
  }

  isFormComplete(Formdevice: any) {
    return Formdevice?.get('ResultComment')?.valid &&
      Formdevice?.get('ResultStatus')?.valid;
  }


   findUpwardTrendBounds(signal : any) {
    const diff = [];
    for (let i = 1; i < signal.length; i++) {
        diff.push(signal[i] - signal[i - 1]);
    }
    debugger
    console.log(diff)

    let startIdx = null;
    for (let i = 0; i < diff.length - 5; i++) {
        let allPositive = true;
        for (let j = i; j < i + 5; j++) {
            if (diff[j] <= 0) {
                allPositive = false;
                break;
            }
        }
        if (allPositive) {
            startIdx = i;
            break;
        }
    }

    const peakIdx = signal.indexOf(Math.max(...signal));
    let endIdx = null;
    for (let i = peakIdx; i < diff.length - 5; i++) {
        let allNegative = true;
        for (let j = i; j < i + 5; j++) {
            if (diff[j] >= 0) {
                allNegative = false;
                break;
            }
        }
        if (allNegative) {
            endIdx = i;
            break;
        }
    }

    return [startIdx, endIdx];
}

getImageUrl(fileName: string): Observable<string> {
    return this.fileService.getBlobSASURL(fileName, 'floor-plans').pipe(
      map((res: any) => res.data as string) 
    );
  }



  
  

}
